export default __webpack_public_path__ + "static/media/filter_icon.f1603e13.svg";